import { useTenantStore } from '@/stores/tenant.js';

/**
 * Per-tenant localStorage namespace: `${tenantId}.player.${name}`. White-label
 * builds isolate persisted state per brand. Until /site-config resolves the
 * tenantId we use the stable `b1fr0st` fallback so first-paint reads/writes
 * still land in one predictable bucket.
 */
export function storageKey(name: string): string {
  const tid = useTenantStore.getState().tenantId ?? 'b1fr0st';
  return `${tid}.player.${name}`;
}
